// src/components/Layout/Footer.js
import React from 'react';
import { 
  Box, 
  Container, 
  Link as MuiLink, 
  Stack, 
  Typography, 
  Divider,
  Grid,
  useTheme
} from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

export default function Footer() {
  const theme = useTheme();
  
  const footerLinks = [
    { title: 'Legal', links: [
      { name: 'Terms of Service', path: '/terms' },
      { name: 'Privacy Policy', path: '/privacy' },
      { name: 'Cookie Policy', path: '/cookies' },
    ]},
  ];

  return (
    <Box
      component="footer"
      sx={{
        bgcolor: theme.palette.grey[100],
        borderTop: `1px solid ${theme.palette.divider}`,
        mt: 'auto',
        py: { xs: 6, md: 8 },
      }}
    >
      <Container maxWidth="lg">
        <Grid container spacing={4}>
          {/* Logo and tagline */}
          <Grid item xs={12} md={4}>
            <Box
              component="img"
              src="/logo.svg"
              alt="OnlyStats Logo"
              sx={{ height: 40, mb: 2 }}
            />
            <Typography variant="body2" color="text.secondary" sx={{ mb: 2, maxWidth: 300 }}>
              Find the best OnlyFans creators with verified reviews from real subscribers.
            </Typography>
          </Grid>
          
          {/* Footer links */}
          {footerLinks.map((section) => (
            <Grid item xs={6} sm={4} md={2} key={section.title}>
              <Typography 
                variant="subtitle2" 
                color="text.primary" 
                sx={{ fontWeight: 600, mb: 2 }}
              >
                {section.title}
              </Typography>
              <Stack spacing={1.5}>
                {section.links.map((link) => (
                  <MuiLink
                    key={link.name}
                    component={RouterLink}
                    to={link.path}
                    underline="hover"
                    color="text.secondary"
                    sx={{ 
                      fontSize: '0.875rem',
                      transition: 'all 0.2s',
                      '&:hover': {
                        color: 'primary.main',
                        transform: 'translateX(2px)'
                      },
                      display: 'inline-block'
                    }}
                  >
                    {link.name}
                  </MuiLink>
                ))}
              </Stack>
            </Grid>
          ))}
          
          {/* Newsletter - placeholder for future */}
          <Grid item xs={12} md={4}>
            <Typography 
              variant="subtitle2" 
              color="text.primary" 
              sx={{ fontWeight: 600, mb: 2 }}
            >
              Stay Updated
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
              Subscribe to our newsletter for the latest updates and features.
            </Typography>
            {/* Newsletter form would go here */}
          </Grid>
        </Grid>
        
        <Divider sx={{ my: 4 }} />
        
        {/* Copyright */}
        <Box
          sx={{
            display: 'flex',
            flexDirection: { xs: 'column', sm: 'row' },
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: 2
          }}
        >
          <Typography variant="body2" color="text.secondary">
            © {new Date().getFullYear()} OnlyStats. All rights reserved.
          </Typography>
          
          <Stack 
            direction="row" 
            spacing={3}
            divider={<Box component="span" sx={{ color: 'text.disabled' }}>•</Box>}
          >
            <MuiLink
              component={RouterLink}
              to="/terms"
              underline="hover"
              color="text.secondary"
              variant="body2"
            >
              Terms
            </MuiLink>
            <MuiLink
              component={RouterLink}
              to="/privacy"
              underline="hover"
              color="text.secondary"
              variant="body2"
            >
              Privacy
            </MuiLink>
            <MuiLink
              component={RouterLink}
              to="/cookies"
              underline="hover"
              color="text.secondary"
              variant="body2"
            >
              Cookies
            </MuiLink>
          </Stack>
        </Box>
      </Container>
    </Box>
  );
}
